const WithdrawalEmailOptions = {
    Candidate_withdrawal: 1,
    Role_no_longer_available: 2,
};

export default WithdrawalEmailOptions;